import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

import ForgotPassword from '../components/ForgotPassword.vue';
import ResetPassword from '../components/ResetPassword.vue';
import EmailVerified from '../components/EmailVerified.vue';
import Unsubscribe from '../components/Unsubscribe.vue';
import AppEncapsulated from '../components/AppEncapsulated.vue';
import SearchMapExample from '../components/SearchMapExample.vue';
import UtahDrawInfo from '../components/UtahDrawInfo.vue';
import UtahHuntLogin from '../components/UtahHuntLogin.vue';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppEncapsulated,
  },
  {
    path: '/utah-draw-info',
    name: 'UtahDrawInfo',
    component: UtahDrawInfo,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/email-verified',
    name: 'EmailVerified',
    component: EmailVerified
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe
  },
  {
    path: '/search-map',
    name: 'SearchMap',
    component: SearchMapExample,
    meta: { requiresAuth: false }
  },
  {
    path: '/utah-hunt-login',
    name: 'UtahHuntLogin',
    component: UtahHuntLogin,
    meta: { requiresAuth: false }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard to check authentication for routes that require it
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is authenticated using the getter
    if (!store.getters.isAuthenticated) {
      // Redirect to home with signin parameter
      next({
        path: '/',
        query: { signin: 'true' }
      });
      // Show alert after navigation
      setTimeout(() => {
        alert('You must be signed in to access this page.');
      }, 100);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
